import { z } from 'zod/v4';

/**
 * The `type` values the asset-link list accepts — the legacy
 * `ASSESSMENT_ASSET_LINK_TYPES`, verbatim.
 *
 * Only eight of these can match a row: the five certification types plus
 * `CERTIFICATE` (all from `certifications.type`), `COMPANY_DOCUMENT` and
 * `AUDIT`. `CERTIFICATEGROUP`, `FILE`, `COMPANY_TABLE` and `COMPANY_ESG_TABLE`
 * name answer kinds with no backing table, so they answer an empty list, as they
 * always did. They stay accepted rather than turning into 400s.
 */
export const QUESTION_ASSET_LINK_TYPES = [
  'CERTIFICATEGROUP',
  'CERTIFICATE',
  'COMPANY_DOCUMENT',
  'FILE',
  'COMPANY_TABLE',
  'COMPANY_ESG_TABLE',
  'AUDIT',
  'MEMBERSHIP',
  'PRODUCT',
  'TRANSACTION',
  'COMPANY',
  'SCOPE',
] as const;

export type QuestionAssetLinkType = (typeof QUESTION_ASSET_LINK_TYPES)[number];

export const AdminQuestionAssetLinksListQuerySchema = z.object({
  /** Narrows the list to one type. Absent → every linkable type except `CERTIFICATE`. */
  type: z.enum(QUESTION_ASSET_LINK_TYPES).optional(),
});

export type AdminQuestionAssetLinksListQuery = z.infer<
  typeof AdminQuestionAssetLinksListQuerySchema
>;

/**
 * One asset a question can link to: a certification, a company document type or
 * an audit type.
 *
 * `name` is nullable because `certifications.name` and
 * `audits_service_audit_types.name` are; `document_types.title` is not.
 */
export const AdminQuestionAssetLinkSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  type: z.string(),
});

export type AdminQuestionAssetLink = z.infer<
  typeof AdminQuestionAssetLinkSchema
>;

export const AdminQuestionAssetLinksListResponseSchema = z.array(
  AdminQuestionAssetLinkSchema,
);

export type AdminQuestionAssetLinksListResponse = z.infer<
  typeof AdminQuestionAssetLinksListResponseSchema
>;
